import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgentiProiecteComponent } from './agenti-proiecte.component';
import { AddAgentiProiecteComponent } from './add-agenti-proiecte/add-agenti-proiecte.component';
import { EditAgentiProiecteComponent } from './edit-agenti-proiecte/edit-agenti-proiecte.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';



@NgModule({
    declarations: [
        AgentiProiecteComponent,
        AddAgentiProiecteComponent,
        EditAgentiProiecteComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [AgentiProiecteComponent],
})
export class AgentiProiecteModule { }
